import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import {MiscLayout} from '../Layout';

function MiscellaneousTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    return (
            <FormField
                currrentUser={currentUser}
                layoutId='f059a441-fb01-4f0b-8ee0-0ccc36cd84e7'
                layoutName='OMTransactionprofileMiscellaneousForm'
                defaultFormSchema={MiscLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.handleMiscFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(MiscellaneousTab);
